import React, { useState } from 'react'
import './slider-banner-galery.scss';
import 'swiper/swiper-bundle.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import PreviewYoutube from '../preview-youtube/preview-youtube';
import useMobile from '../../../hooks/useMobile';

SwiperCore.use([Navigation, Pagination]);

const SliderBannerGalery = props => {
   
    const { maxShow, banner, logo, promo } = props;
    const [ slider, setSlider ] = useState(null);
    const [ activeIndex, setActiveIndex ] = useState(0);
    const isMobile = useMobile();
    let haveImage = false;
    const max = banner ? banner.length : 1;    
    haveImage = (
            banner.find(item => item.__typename === 'ContentfulImagenBanner' )
        ) ? true : false
    console.log(haveImage)
    
    return (
        <div className="a-slider-galery">
            <Swiper
                onActiveIndexChange={ (e) => setActiveIndex( e.activeIndex ) }
                slidesPerView={'auto'}
                className={"swiper-my "}
                onSwiper={ setSlider }                
                spaceBetween={0}                             
                pagination={promo && isMobile ? 
                    false            
                
                : { clickable: true}
                }
            >
                {
                    banner &&
                    banner.slice(0, maxShow ? maxShow : banner.length).map((item, index) => [
                        <SwiperSlide key={index}>
                            {
                                item.__typename === 'ContentfulImagenBanner' ? (
                                    <div className="a-card-sale-img">
                                        <img src={ item.imagenBanner.file.url } alt={ `imagen de ${item.titulo} ${index + 1}`} title={item.titulo}/>
                                    </div>
                                ) 
                                :                                    
                                <PreviewYoutube info={item.url} />
                            }
                        </SwiperSlide>                           
                    ])
                }                
            </Swiper>
            {            
                (max > 1 && activeIndex > 0 ) &&
                <div className="a-slider-galery-arrow prev" onClick={() => {slider.slidePrev(); setActiveIndex(activeIndex - 1)}}>
                    <i className="fal fa-arrow-left"></i>
                </div>
            }
            
            { 
                (max > 1 && activeIndex < max - 1 ) &&
                <div className="a-slider-galery-arrow next" onClick={() => { slider.slideNext(); setActiveIndex(activeIndex + 1)}}>
                    <i className="fal fa-arrow-right"></i>
                </div>
            }
            {
                logo && 
                <div className="o-galerry-carrousel_logo-container">
                    <img src={ logo.file.url } alt="logo de carrousel"></img>
                </div>
            }
        </div>
    )
}

export default SliderBannerGalery
